import { render, staticRenderFns } from "./FiltersSaveForm.vue?vue&type=template&id=6d31b2f8&scoped=true&lang=pug&"
import script from "./FiltersSaveForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./FiltersSaveForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FiltersSaveForm.vue?vue&type=style&index=0&id=6d31b2f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31b2f8",
  null
  
)

export default component.exports